import React, { useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { BookOpen, UtensilsCrossed, Wine } from 'lucide-react';
import { useRestaurant } from '../context/RestaurantContext';

import MenusList from '../components/menu/MenusList';
import DishesList from '../components/menu/DishesList';
import BeveragesList from '../components/menu/BeveragesList';
import AllDishesList from '../components/menu/AllDishesList';

function MenuManagementParent({ restaurantId: restaurantIdProp, activeTab = 'menus' }) {
  const { restaurantId: contextRestaurantId, setRestaurantId } = useRestaurant();
  
  // Use the provided restaurantId if available, otherwise use context
  const restaurantId = restaurantIdProp || contextRestaurantId;

  // Update context when restaurantIdProp changes
  useEffect(() => {
    if (restaurantIdProp) {
      setRestaurantId(restaurantIdProp);
    }
  }, [restaurantIdProp, setRestaurantId]);

  if (!restaurantId) {
    return (
      <div className="w-full p-6">
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg">No restaurant selected. Please select a restaurant first.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full p-6">
      <div className="mb-6">
        <h1 className="font-display text-3xl font-semibold text-foreground tracking-tight leading-none flex items-center gap-2">
          <BookOpen className="h-8 w-8" />
          Menu Management
        </h1>
      </div>

      <Tabs value={activeTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 mb-6 hidden">
          <TabsTrigger value="menus" className="flex items-center gap-2">
            <BookOpen className="h-4 w-4" />
            Menus
          </TabsTrigger>
          <TabsTrigger value="dishes" className="flex items-center gap-2">
            <UtensilsCrossed className="h-4 w-4" />
            Dishes
          </TabsTrigger>
          <TabsTrigger value="beverages" className="flex items-center gap-2">
            <Wine className="h-4 w-4" />
            Beverages
          </TabsTrigger>
        </TabsList>

        <TabsContent value="menus">
          <MenusList restaurantId={restaurantId} />
        </TabsContent>

        <TabsContent value="dishes">
          <DishesList restaurantId={restaurantId} dishType="food" />
        </TabsContent>

        <TabsContent value="beverages">
          <BeveragesList restaurantId={restaurantId} dishType="beverage" />
        </TabsContent>

        <TabsContent value="allDishes">
          <AllDishesList restaurantId={restaurantId} />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default MenuManagementParent;
